import React, { useState, useReducer } from 'react'
import './css/AddMenu.css'
import AnimateHeight from 'react-animate-height';
import { AnimatePresence, motion } from 'framer-motion';

//firebase stuff
import {firebase} from './firebase';
import {collectionRef, db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';

//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn"

///remember to set some kind of auth() check, otherwise return to 'signin' screen



const Home = React.memo(props => {

    const [noun, setNoun] = useState('');
    const [nounTranslation, setNounTranslation] = useState('');
     //verbs
     const [verb, setVerb] = useState('');
     const [verbTranslation, setVerbTranslation] = useState('');
     const [verbI,setVerbI] = useState('');
     const [verbYou,setVerbYou] = useState('');
     const [verbHe,setVerbHe] = useState('');
     const [verbWe,setVerbWe] = useState('');
     const [verbYall,setVerbYall] = useState('');
     const [verbThey,setVerbThey] = useState('');

     //verbs Past
     const [verbPast, setVerbPast] = useState('');
     const [verbTranslationPast, setVerbTranslationPast] = useState('');
     const [verbIPast,setVerbIPast] = useState('');
     const [verbYouPast,setVerbYouPast] = useState('');
     const [verbHePast,setVerbHePast] = useState('');
     const [verbWePast,setVerbWePast] = useState('');
     const [verbYallPast,setVerbYallPast] = useState('');
     const [verbTheyPast,setVerbTheyPast] = useState('');


    const [phrase, setPhrase] = useState('');
    const [phraseTranslation, setPhraseTranslation] = useState('');


    const [selectedSection, setSelectedSection] = useState(''); 
    const [active, setActive] = useState(''); 
    const [nounHeight, setNounHeight] = useState(36); 
    const [verbHeight, setVerbHeight] = useState(36); 
    const [verbHeightPast, setVerbHeightPast] = useState(36); 
    const [phraseHeight, setPhraseHeight] = useState(36); 
    const [titleAlign, setTitleAlign] = useState(''); 
    const [paragraghAlign, setParagraghAlign] = useState(''); 

    const [loading, setloading] = useState(false); //for the loading gif
    const [finishedUpload, setFinishedUpload] = useState(false); //to display the text after upload complete
    const [overlayTextFade, setOverlayTextFade] = useState('hideOverlayTextFade'); //sets css classes so the fadeOut animation doesnt play at the first load
    const [redBorder, setRedBorder] = useState(false); //for the loading gif

    const [nounOverlayTextFade, setNounOverlayTextFade] = useState('hideOverlayTextFade');
    const [verbOverlayTextFade, setVerbOverlayTextFade] = useState('hideOverlayTextFade');
    const [verbOverlayTextFadePast, setVerbOverlayTextFadePast] = useState('hideOverlayTextFade');
    const [phraseOverlayTextFade, setPhraseOverlayTextFade] = useState('hideOverlayTextFade');


    //redux
    // const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
    const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
    // const reduxFirstAppLoad = useSelector((state) => state.firstAppLoad.reduxFirstAppLoad);
    // const reduxUserName = useSelector((state) => state.isLoggedIn.reduxUserName);
    // const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);
    const [isOpen, setIsOpen] = useState(false)

    //create the DB paths to put the data into
    const nounRef = collection(db,"users",reduxUserID,"nouns");
    const verbRef = collection(db,"users",reduxUserID,"verbs");
    const verbRefPast = collection(db,"users",reduxUserID,"verbsPast");
    const phraseRef = collection(db,"users",reduxUserID,"phrases");



    function missingReducer(verbsMissing,action){
        switch(action.type){
             case 'verb':{ return{ ...verbsMissing, verb: action.payload.verb} }
             case 'infinitive':{ return{ ...verbsMissing, infinitive: action.payload.infinitive} }
             case 'I':{ return{ ...verbsMissing, I: action.payload.I} }
             case 'you':{ return{ ...verbsMissing, you: action.payload.you} }
             case 'he':{ return{ ...verbsMissing, he: action.payload.he} }
             case 'we':{ return{ ...verbsMissing, we: action.payload.we} }
             case 'yall':{ return{ ...verbsMissing, yall: action.payload.yall} }
             case 'they':{ return{ ...verbsMissing, they: action.payload.they} }       
        }
   }

   //when using reducers, this is how to set up the 'state'
   const [verbsMissing, dispatch] = useReducer(missingReducer, {verb:false, I:false, you:false, he:false, we:false, yall:false, they:false});  

   function missingPastReducer(verbsPastMissing,action){
    switch(action.type){
         case 'verb':{ return{ ...verbsPastMissing, verb: action.payload.verb} }
         case 'infinitive':{ return{ ...verbsPastMissing, infinitive: action.payload.infinitive} }
         case 'I':{ return{ ...verbsPastMissing, I: action.payload.I} }
         case 'you':{ return{ ...verbsPastMissing, you: action.payload.you} }
         case 'he':{ return{ ...verbsPastMissing, he: action.payload.he} }
         case 'we':{ return{ ...verbsPastMissing, we: action.payload.we} }
         case 'yall':{ return{ ...verbsPastMissing, yall: action.payload.yall} }
         case 'they':{ return{ ...verbsPastMissing, they: action.payload.they} }       
        }
    }

    //when using reducers, this is how to set up the 'state'
    const [verbsPastMissing, dispatchPast] = useReducer(missingPastReducer, {verb:false, I:false, you:false, he:false, we:false, yall:false, they:false});

     ////////////handling the noun and phrase 'missing' when you commit to an empty field
    function missingNounPraseReducer(nounAndPhraseMissing,action){
        switch(action.type){
             case 'noun':{ return{ ...nounAndPhraseMissing, noun: action.payload.noun} }
             case 'nounTranslation':{ return{ ...nounAndPhraseMissing, nounTranslation: action.payload.nounTranslation} }
             case 'phrase':{ return{ ...nounAndPhraseMissing, phrase: action.payload.phrase} }
             case 'phraseTranslation':{ return{ ...nounAndPhraseMissing, phraseTranslation: action.payload.phraseTranslation} }
        }
    }
    const [nounAndPhraseMissing,dispatchNounPhraseMissing] = useReducer(missingNounPraseReducer,{noun:false,nounTranslation:false,phrase:false,phraseTranslation:false}); 




    const stretch = (current) => {
        setIsOpen(true);
        setActive(current);
        //console.log(current);
        //redundant but the only way for now. we cant use ternary ops in the <Animate> thing
        if(current == "nounArea"){
            setNounHeight('auto');
        }
        else{
            setNounHeight(30);
        }
        if(current == "verbArea"){
            setVerbHeight('auto');
        }
        else{
            setVerbHeight(30);
        }
        if(current == "verbAreaPast"){
            setVerbHeightPast('auto');
        }
        else{
            setVerbHeightPast(30);
        }
        if(current == "phraseArea"){
            setPhraseHeight('auto');
        }
        else{
            setPhraseHeight(30);
        }
    }//end stretch()

    
    /////////////////////////////////////////////////upload to DB functions/////////////////////////
    const addNoun = (item) => {

        if(noun && nounTranslation !== ""){
          
            setloading(true);

            //////firebase code
            addDoc(nounRef,{
                noun: noun,
                translation: nounTranslation,
                date: Date.now() 
            }).then(() => {
               //console.log("noun added");
                setNounTranslation('');
                setNoun('');
                setloading(false);
                setFinishedUpload(true);
                ///////hacky as hell but its what ive got
                setTimeout(function(){
                    setNounOverlayTextFade("nounOverlayTextFade");
                    setFinishedUpload(false);
                },500);
                setTimeout(function(){
                    setNounOverlayTextFade("hideOverlayTextFade");
                },1000);        
            });
        }//end if()
        else{
            if(noun == '' ){ dispatchNounPhraseMissing({type:'noun', payload:{noun:true}}) }
            if(nounTranslation == '' ){ dispatchNounPhraseMissing({type:'nounTranslation', payload:{nounTranslation:true}}) }
            setRedBorder(true);
            setTimeout(function(){
                setRedBorder(false);
            },400);
        }

    }

    const addVerb = (item) => {
        if(verb !== "" && verbTranslation !== "" && verbI !== "" && verbYou !== "" && verbHe !== "" && verbWe !== "" && verbYall !== "" && verbThey !== ""){
            setloading(true);

            //////firebase code
            addDoc(verbRef,{
                verb: verb,
                pureForm: verbTranslation,
                I: verbI,
                you: verbYou,
                he: verbHe,
                we: verbWe,
                yall: verbYall,
                they: verbThey,
                date: Date.now()
            }).then(() => {
                //console.log("verb added");
                setVerbTranslation('');
                setVerb('');
                setVerbI('');
                setVerbYou('');
                setVerbHe('');
                setVerbWe('');
                setVerbYall('');
                setVerbThey('');
                setloading(false);
                setFinishedUpload(true);
                ///////hacky as hell but its what ive got
                setTimeout(function(){
                    setVerbOverlayTextFade("verbOverlayTextFade");
                    setFinishedUpload(false);
                    },500);
                    setTimeout(function(){
                        setVerbOverlayTextFade("hideOverlayTextFade");
                },1000);        
            });
        }//end if()
        else{

            if(verb == '' ){ dispatch({type:'verb', payload:{verb:true}}) }
            if(verbTranslation == '' ){ dispatch({type:'infinitive', payload:{infinitive:true}}) }
            if(verbI == '' ){ dispatch({type:'I', payload:{I:true}}) }
            if(verbYou == '' ){ dispatch({type:'you', payload:{you:true}}) }
            if(verbHe == '' ){ dispatch({type:'he', payload:{he:true}}) }
            if(verbWe == '' ){ dispatch({type:'we', payload:{we:true}}) }
            if(verbYall == '' ){ dispatch({type:'yall', payload:{yall:true}}) }
            if(verbThey == '' ){ dispatch({type:'they', payload:{they:true}}) }

            setRedBorder(true);
            setTimeout(function(){
                setRedBorder(false);
            },400);
        }

    }


    const addVerbPast = (item) => {
        if(verbPast !== "" && verbTranslationPast !== "" && verbIPast !== "" && verbYouPast !== "" && verbHePast !== "" && verbWePast !== "" && verbYallPast !== "" && verbTheyPast !== ""){
            setloading(true);

            //////firebase code
            addDoc(verbRefPast,{
                verb: verbPast,
                pureForm: verbTranslationPast,
                I: verbIPast,
                you: verbYouPast,
                he: verbHePast,
                we: verbWePast,
                yall: verbYallPast,
                they: verbTheyPast,
                date: Date.now()
            }).then(() => {
                //console.log("verb added");
                setVerbTranslationPast('');
                setVerbPast('');
                setVerbIPast('');
                setVerbYouPast('');
                setVerbHePast('');
                setVerbWePast('');
                setVerbYallPast('');
                setVerbTheyPast('');
                setloading(false);
                setFinishedUpload(true);
                ///////hacky as hell but its what ive got
                setTimeout(function(){
                    setVerbOverlayTextFadePast("verbOverlayTextFadePast");
                    setFinishedUpload(false);
                    },500);
                    setTimeout(function(){
                        setVerbOverlayTextFadePast("hideOverlayTextFade");
                },1000);        
            });
        }//end if()
        else{

            if(verbPast == '' ){ dispatchPast({type:'verb', payload:{verb:true}}) }
            if(verbTranslationPast == '' ){ dispatchPast({type:'infinitive', payload:{infinitive:true}}) }
            if(verbIPast == '' ){ dispatchPast({type:'I', payload:{I:true}}) }
            if(verbYouPast == '' ){ dispatchPast({type:'you', payload:{you:true}}) }
            if(verbHePast == '' ){ dispatchPast({type:'he', payload:{he:true}}) }
            if(verbWePast == '' ){ dispatchPast({type:'we', payload:{we:true}}) }
            if(verbYallPast == '' ){ dispatchPast({type:'yall', payload:{yall:true}}) }
            if(verbTheyPast == '' ){ dispatchPast({type:'they', payload:{they:true}}) }

            setRedBorder(true);
            setTimeout(function(){
                setRedBorder(false);
            },400);
        }

    }

    const addPhrase = (item) => {
        if(phrase && phraseTranslation !== ""){
            setloading(true);

            //////firebase code
            addDoc(phraseRef,{
                phrase: phrase,
                translation: phraseTranslation,
                date: Date.now()
            }).then(() => {
                //console.log("phrase added");
                setPhraseTranslation('');
                setPhrase('');
                setloading(false);
                setFinishedUpload(true);
                ///////hacky as hell but its what ive got
                setTimeout(function(){
                    setPhraseOverlayTextFade("phraseOverlayTextFade");
                    setFinishedUpload(false);
                },500);
                setTimeout(function(){
                    setPhraseOverlayTextFade("hideOverlayTextFade");
                },1000);        
            });
        }//end if()
        else{
            if(phrase == '' ){ dispatchNounPhraseMissing({type:'phrase', payload:{phrase:true}}) }
            if(phraseTranslation == '' ){ dispatchNounPhraseMissing({type:'phraseTranslation', payload:{phraseTranslation:true}}) }
            setRedBorder(true);
            setTimeout(function(){
                setRedBorder(false);
            },400);
        }
    }
    /////////////////////////////////////////////////END upload to DB functions/////////////////////////


    //// varients allow for conditional settings in Framer Motion
    const variants = {
        open: { opacity: 1, scale: 1.2 },
        closed: { opacity: 0, scale: 1  },
      }


    return (
        <motion.div initial={{x:-768, opacity:0}} animate={{x:0, opacity:1}} exit={{x:768, opacity:0}} transition={{duration:0.2}}>
            <div className='addMenuContainer'>

                {/* ////////////////////////////////////////Add a Noun Option//////////////////////////////////////////////////// */}
                <div 
                    className={ redBorder && active == 'nounArea' ? "addMenuOptionWrapper redBorder": 'addMenuOptionWrapper'}
                    onClick = { () =>{ stretch("nounArea") }}
                 >
                    
                    <div className={active == 'nounArea' && loading == true ? "overlay" : ""}>
                        <div className={active == 'nounArea' && finishedUpload == true ? "overlayText" : nounOverlayTextFade }>Your Noun has been added!</div>
                    </div>
                    
                    <motion.button 
                        className='addButton'
                        onClick={addNoun} 
                        animate={ active == 'nounArea' ? "open" : "closed"}
                        transition={{ duration: 0.1}}
                        variants={variants}
                        style = {{pointerEvents: active == 'nounArea' ? "" : "none"}} //so you cant click button before its visible
                    >
                        Add
                    </motion.button>  

                    <div className='paddingEffect'>
                        <AnimateHeight   
                            duration={ 200 }
                            height={nounHeight}
                        >
                            <div className={active == "nounArea" ? 'textInputTitle animateLeft' : 'textInputTitle'}>
                                <p className={active == "nounArea" ? 'animateLeft-P' : ''} >Add a Noun</p>
                            </div>



                            <input type='text' value={noun} 
                                placeholder={ nounAndPhraseMissing.noun ? "Enter Value" : "Your Noun"  }
                                className={ nounAndPhraseMissing.noun ? 'textInputField missing' : 'textInputField '}
                                onChange = {(event) => setNoun(event.target.value)}
                                onFocus = { () => dispatchNounPhraseMissing({type:'noun', payload:{noun:false}})  } 
                            />

                            <input type='text' value={nounTranslation} 
                                placeholder={ nounAndPhraseMissing.nounTranslation ? "Enter Value" : "Your Noun Translation"  }
                                className={ nounAndPhraseMissing.nounTranslation ? 'textInputField missing' : 'textInputField '}
                                onChange = {(event) => setNounTranslation(event.target.value)}
                                onFocus = { () => dispatchNounPhraseMissing({type:'nounTranslation', payload:{nounTranslation:false}})  }  
                            />
                        </AnimateHeight>
                    </div>
                </div>




                {/* ////////////////////////////////////////Add a Verb Option//////////////////////////////////////////////////// */}
                <div 
                    className={ redBorder && active == 'verbArea' ? "addMenuOptionWrapper redBorder" :  'addMenuOptionWrapper'}
                    onClick = { () =>{ stretch("verbArea") }}
                 >
                   
                    <div className={active == 'verbArea' && loading == true ? "overlay" : ""}>
                        <div className={active == 'verbArea' && finishedUpload == true ? "overlayText" : verbOverlayTextFade }>Your Verb has been added!</div>
                    </div>
    
                    <motion.button 
                            className='addButton'
                            onClick={addVerb} 
                            animate={ active == 'verbArea' ? "open" : "closed"}
                            transition={{ duration: 0.1}}
                            variants={variants}
                            style = {{pointerEvents: active == 'verbArea' ? "" : "none"}} //so you cant click button before its visible
                        >
                        Add
                    </motion.button>  

                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={verbHeight}
                         >
                                <div className={active == "verbArea" ? 'textInputTitle animateLeft' : 'textInputTitle'}>
                                    <p className={active == "verbArea" ? 'animateLeft-P' : ''} >Add a Verb <span>(Present)</span></p>
                                </div>

                                <div className='left'>
                                    <input type='text' value={verb} 
                                        placeholder={ verbsMissing.verb ? "Enter Value" : "Your Verb"  }
                                        className={ verbsMissing.verb ? 'textInputField pureVerb missing' : 'textInputField pureVerb'}
                                        onChange = {(event) => setVerb(event.target.value)} 
                                        onFocus = { () => dispatch({type:'verb', payload:{verb:false}})  }
                                    />
                                </div>
                                <div className='right'>
                                    <input type='text' value={verbTranslation} 
                                       placeholder={ verbsMissing.infinitive ? "Enter Value" : "Infinitive"  }
                                        className={ verbsMissing.infinitive ? 'textInputField pureVerb missing' : 'textInputField pureVerb'}
                                        onChange = {(event) => setVerbTranslation(event.target.value)}
                                        onFocus = { () => dispatch({type:'infinitive', payload:{infinitive:false}})  } 
                                    />
                                </div>

                                   <div className='divide'></div>

                                   <div className='left'>
                                        <input type='text' value={verbI} 
                                            placeholder={ verbsMissing.I ? "Enter Value" : "I"  }
                                            className={ verbsMissing.I ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbI(event.target.value)}
                                            onFocus = { () => dispatch({type:'I', payload:{I:false}})  }  
                                        />

                                        <input type='text' value={verbYou} 
                                            placeholder={ verbsMissing.you ? "Enter Value" : "You"  }
                                            className={ verbsMissing.you ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbYou(event.target.value)}
                                            onFocus = { () => dispatch({type:'you', payload:{you:false}})  }  
                                        />

                                        <input type='text' value={verbHe} 
                                            placeholder={ verbsMissing.he ? "Enter Value" : "he/she"  }
                                            className={ verbsMissing.he ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbHe(event.target.value)}
                                            onFocus = { () => dispatch({type:'he', payload:{he:false}})  }   
                                        />

                                   </div>

                                   <div className='right'>
                                        <input type='text' value={verbWe} 
                                            placeholder={ verbsMissing.we ? "Enter Value" : "we"  }
                                            className={ verbsMissing.we ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbWe(event.target.value)}
                                            onFocus = { () => dispatch({type:'we', payload:{we:false}})  }   
                                        />

                                        <input type='text' value={verbYall} 
                                            placeholder={ verbsMissing.yall ? "Enter Value" : "yall"  }
                                            className={ verbsMissing.yall ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbYall(event.target.value)}
                                            onFocus = { () => dispatch({type:'yall', payload:{yall:false}})  }   
                                        />

                                        <input type='text' value={verbThey} 
                                            placeholder={ verbsMissing.they ? "Enter Value" : "they"  }
                                            className={ verbsMissing.they ? 'textInputField  missing' : 'textInputField'}
                                            onChange = {(event) => setVerbThey(event.target.value)}
                                            onFocus = { () => dispatch({type:'they', payload:{they:false}})  }   
                                        />                                                                                
                                   </div>


                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
                </div>




  {/* ////////////////////////////////////////Add a Verb PAST Option//////////////////////////////////////////////////// */}
  <div 
                    className={ redBorder && active == 'verbAreaPast' ? "addMenuOptionWrapper redBorder" :  'addMenuOptionWrapper'}
                    onClick = { () =>{ stretch("verbAreaPast") }}
                 >
                   
                    <div className={active == 'verbAreaPast' && loading == true ? "overlay" : ""}>
                        <div className={active == 'verbAreaPast' && finishedUpload == true ? "overlayText" : verbOverlayTextFadePast }>Your Verb has been added!</div>
                    </div>
    
                    <motion.button 
                            className='addButton'
                            onClick={addVerbPast} 
                            animate={ active == 'verbAreaPast' ? "open" : "closed"}
                            transition={{ duration: 0.1}}
                            variants={variants}
                            style = {{pointerEvents: active == 'verbAreaPast' ? "" : "none"}} //so you cant click button before its visible
                        >
                        Add
                    </motion.button>  

                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={verbHeightPast}
                         >
                                <div className={active == "verbAreaPast" ? 'textInputTitle animateLeft' : 'textInputTitle'}>
                                    <p className={active == "verbAreaPast" ? 'animateLeft-P' : ''} >Add a Verb <span>(Past)</span></p>
                                </div>

                                <div className='left'>
                                    <input type='text' value={verbPast} 
                                        placeholder={ verbsPastMissing.verb ? "Enter Value" : "Your Verb"  }
                                        className={ verbsPastMissing.verb ? 'textInputField pureVerb missing' : 'textInputField pureVerb'}
                                        onChange = {(event) => setVerbPast(event.target.value)}
                                        onFocus = { () => dispatchPast({type:'verb', payload:{verb:false}})  }    
                                    />
                                </div>
                                <div className='right'>
                                    <input type='text' value={verbTranslationPast} 
                                        placeholder={ verbsPastMissing.infinitive ? "Enter Value" : "Your Verb"  }
                                        className={ verbsPastMissing.infinitive ? 'textInputField pureVerb missing' : 'textInputField pureVerb'}
                                        onChange = {(event) => setVerbTranslationPast(event.target.value)}
                                        onFocus = { () => dispatchPast({type:'infinitive', payload:{infinitive:false}})  }   
                                    />                              
                                </div>


                                   <div className='divide'></div>

                                   <div className='left'>
                                        <input type='text' value={verbIPast} 
                                            placeholder={ verbsPastMissing.I ? "Enter Value" : "I"  }
                                            className={ verbsPastMissing.I ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbIPast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'I', payload:{I:false}})  }    
                                        />

                                        <input type='text' value={verbYouPast} 
                                            placeholder={ verbsPastMissing.you ? "Enter Value" : "you"  }
                                            className={ verbsPastMissing.you ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbYouPast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'you', payload:{you:false}})  }   
                                        />

                                        <input type='text' value={verbHePast} 
                                            placeholder={ verbsPastMissing.he ? "Enter Value" : "he/she"  }
                                            className={ verbsPastMissing.he ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbHePast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'he', payload:{he:false}})  }   
                                        />

                                   </div>

                                   <div className='right'>
                                        <input type='text' value={verbWePast} 
                                            placeholder={ verbsPastMissing.we ? "Enter Value" : "we"  }
                                            className={ verbsPastMissing.we ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbWePast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'we', payload:{we:false}})  }  
                                        />

                                        <input type='text' value={verbYallPast} 
                                            placeholder={ verbsPastMissing.yall ? "Enter Value" : "yall"  }
                                            className={ verbsPastMissing.yall ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbYallPast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'yall', payload:{yall:false}})  }   
                                        />

                                        <input type='text' value={verbTheyPast} 
                                            placeholder={ verbsPastMissing.they ? "Enter Value" : "they"  }
                                            className={ verbsPastMissing.they ? 'textInputField missing' : 'textInputField'}
                                            onChange = {(event) => setVerbTheyPast(event.target.value)}
                                            onFocus = { () => dispatchPast({type:'they', payload:{they:false}})  }  
                                        />                                                                                
                                   </div>


                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
                </div>












                {/* ////////////////////////////////////////Add a Phrase Option//////////////////////////////////////////////////// */}
                <div 
                    className={ redBorder && active == 'phraseArea' ? "addMenuOptionWrapper redBorder" :  'addMenuOptionWrapper'}
                    onClick = { () =>{ stretch("phraseArea") }}
                 >
                    
                    <div className={active == 'phraseArea' && loading == true ? "overlay" : ""}>
                        <div className={active == 'phraseArea' && finishedUpload == true ? "overlayText" : phraseOverlayTextFade }>Your Phrase has been added</div>
                    </div>  

                    <motion.button 
                            className='addButton'
                            onClick={addPhrase} 
                            animate={ active == 'phraseArea' ? "open" : "closed"}
                            transition={{ duration: 0.1}}
                            variants={variants}
                            style = {{pointerEvents: active == 'phraseArea' ? "" : "none"}} //so you cant click button before its visible
                        >
                        Add
                    </motion.button>  

                    <div className='paddingEffect'>
                        <AnimateHeight   
                            duration={ 200 }
                            height={phraseHeight}
                        >
                            <div className={active == "phraseArea" ? 'textInputTitle animateLeft' : 'textInputTitle'}>
                                <p className={active == "phraseArea" ? 'animateLeft-P' : ''} >Add a Phrase</p>
                            </div>

                            <input type='text' value={phrase} 
                                placeholder={ nounAndPhraseMissing.phrase ? "Enter Value" : "Your phrase"  }
                                className={ nounAndPhraseMissing.phrase ? 'textInputField missing' : 'textInputField '}
                                onChange = {(event) => setPhrase(event.target.value)}
                                onFocus = { () => dispatchNounPhraseMissing({type:'phrase', payload:{phrase:false}})  } 
                            />

                            <input type='text' value={phraseTranslation} 
                                placeholder={ nounAndPhraseMissing.phraseTranslation ? "Enter Value" : "Enter the translation"  }
                                className={ nounAndPhraseMissing.phraseTranslation ? 'textInputField missing' : 'textInputField '}
                                onChange = {(event) => setPhraseTranslation(event.target.value)}
                                onFocus = { () => dispatchNounPhraseMissing({type:'phraseTranslation', payload:{phraseTranslation:false}})  } 
                            />
                        </AnimateHeight>
                    </div>
                </div>

            </div>
        </motion.div>
    )
})

export default Home
